import { Tabs, Timeline } from "antd";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  ActiveDotIcon,
  BackIcon,
  CloseIcon,
  InactiveDotIcon,
  PaidIcon,
  UnpaidIcon,
} from "../../../asset";
import Accordion from "../../../component/accordion/Accordion";
import SecondaryButton from "../../../component/button/SecondaryButton";
import MapsSmall from "../../../component/maps/MapsSmall";
import Delete from "../../../component/modal/ModalDelete";
import ModalMaps from "../../../component/modal/ModalMaps";
import Breadcumbs from "../../../component/page-components/breadcumbs/breadcumbs";
import {
  GROLOG_BASE_URL,
  GROLOG_ORDER_URL,
  GROLOG_URL,
} from "../../../constant/apiConstant";
import { ROUTES } from "../../../constant/routeConstant";
import style from "./ShippingCostList.module.css";
import moment from "moment";
import ManagementHistory from "../../../component/management-history/management-history";
import CustomDivider from "../../../component/divider/CustomDivider";
import PrimaryButton from "../../../component/button/PrimaryButton";
import ModalStartEndTrip from "../../../component/modal/ModalStartEndTrip";
import ModalSuccessAdd from "../../../component/modal/ModalSuccessAdd";
import ModalFailedDelete from "../../../component/modal/ModalFailedDelete";
const DetailShippingCost = () => {
  const { token, client_id, grolog_account_id, userId } = useSelector(
    (state) => state.auth
  );
  let param = `CLIENT_ID=${client_id}&RESOURCE_USER_ID=${userId}&GROLOG_ACCOUNT_ID=${grolog_account_id}`;

  const { t } = useTranslation();
  const [form, setForm] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  const [detail, setDetail] = useState([]);
  const [index, setIndex] = useState();
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [isOpenMaps, setIsOpenMaps] = useState(false);
  const [SI, setSI] = useState([]);
  const [indexItem, setIndexItem] = useState();
  const [isOpenItem, setIsOpenItem] = useState(false);

  const [loc, setLoc] = useState("")
  const [loc2, setLoc2] = useState("")
  const [userManagementOpen, setUserManagementOpen] = useState(false);
  const [managementHistoryList, setManagementHistoryList] = useState([]);

  const [failedModalOpen, setFailedModalOpen] = useState(false);
  const [messages, setMessages] = useState("");
  const [isAllPaid, setIsAllPaid] = useState(false)
  const [isAllChecked, setIsAllChecked] = useState(false)
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [startOpen, setStartOpen] = useState(false);

  useEffect(() => {
    fetchData();
    getManagementHistoryList();
  }, []);

  const getAdr = (long, latt) => {
    const geocoder = new window.google.maps.Geocoder();
    const latLng = new window.google.maps.LatLng(latt, long);

    geocoder.geocode({ location: latLng }, (results, status) => {
      if (status === window.google.maps.GeocoderStatus.OK && results[0]) {
        for (let i = 0; i < results[0].address_components.length; i++) {
          const component = results[0].address_components[i];
          if (component.types.includes("administrative_area_level_3")) {
            setLoc(component.long_name)
            return; // Exit the loop if postal code is found
          } if (component.types.includes("administrative_area_level_4")) {
            setLoc2(component.long_name)
            setIsOpenMaps(true)
          }
        }

      } else {
        console.log("Geocoder failed due to:", status);
      }
    })

    setIsOpenMaps(true)
  }
  const api = GROLOG_ORDER_URL;
  const doPut = async (endpoint, tkn, data, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "PUT";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, data };
    return axios(request);
  };

  const doGet = async (endpoint, tkn, params, dispatch, refresh_token) => {
    const url = api + endpoint;
    const method = "GET";
    const headers = { Authorization: tkn };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const doGetBaseUrl = async (
    endpoint,
    tkn,
    params,
    dispatch,
    refresh_token
  ) => {
    const url = GROLOG_BASE_URL + endpoint;
    const method = "GET";
    const headers = { Authorization: token };
    const request = { url, method, headers, params };
    return axios(request);
  };

  const getManagementHistoryList = async () => {
    let res = await doGetBaseUrl(
      `audit/v1/grolog/audit?page=1&filter=table_name eq order, primary_key eq ${location.state}`
    );

    const data = res?.data?.payload;
    const reorderedData = [];

    for (let i = data.length - 1; i >= 0; i--) {
      const element = data[i];
      reorderedData.push(element);
    }

    setManagementHistoryList(reorderedData);
  };

  const convertTimestamp = (timestamp, isSpecific) => {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const monthNumbers = ["01", "02", "03", "04", "05", "06",
      "07", "08", "09", "10", "11", "12"
    ];

    // Extract components from the timestamp string
    const year = timestamp?.substring(0, 4);
    const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
    const day = timestamp?.substring(8, 10);

    let dateFormat = new Date(year, month, day);

    if (isSpecific) {
      return (`${dateFormat.getDate()}-${monthNames[dateFormat.getMonth()]}-${dateFormat.getFullYear()}`)
    } else {
      return (`${dateFormat.getDate()}/${monthNumbers[dateFormat.getMonth()]}/${dateFormat.getFullYear()}`)
    }
  };

  const convertToTime = (timestamp) => {
    let time = new Date(timestamp);
    return moment(timestamp).utc().format("HH:mm");
  };

  const fetchData = async () => {
    let id = 1;
    let tkn = `Grolog2023`;
    let res = await doGet(`/shipping-cost-payment/${location.state}?${param}`, token);
    setDetail(res?.data?.payload?.data);
    setSI(res?.data?.payload?.data?.order_detail?.order_item);
  };

  const clickCard = async (i, open, id) => {
    if(i===index){
    setIsOpen(false);
    setIndex()
    }else{
    setIndex(i);
    setIsOpen(true);
    // let res = await doGet(`/gromart-order/sales-invoice/${id}?${param}`, token);
    // // setSI(res?.data?.payload?.data);
    // let items = [...SI];
    // items[i]["item"] = res?.data?.payload?.data;
    // setSI(items);
    }
  };
  const clickCardItem = async (i, open, id) => {
    if(i===indexItem){
      setIsOpenItem(false);
      setIndexItem()
      }else{
    setIndexItem(i);
    setIsOpenItem(isOpenItem ? false : true);
      }
  };
  console.log("check SI", SI);
  const Order = () => {
    return (
      <>
        <div className="flex flex-col gap-[40px]">
          <div>
            {/* <h3 className="font-roboto text-[18px] font-medium mb-6 mt-6">
              {t("Order Information")}
            </h3> */}
        <CustomDivider name={"Order Information"} />
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Order Group")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.order_detail?.order_group}
                  </h4>
                </div>
                
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Distributor Name")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.order_detail?.distributor_name}
                  </h4>
                </div>
                </div>
                <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Sales Invoice Number")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.order_detail?.sales_invoice_number}
                  </h4>
                </div>
                
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Shipping Cost")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    Rp. {detail?.order_detail?.shipping_cost}
                  </h4>
                </div>
                </div>
                <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Order Number")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.order_detail?.order_no}
                  </h4>
                </div>
                </div>
                </div>
                {/* <h3 className="font-roboto text-[18px] font-medium mb-6 mt-6">
              {t("Item Information")}
            </h3> */}
        <CustomDivider name={"Item Information"} />
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Total Item")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.order_detail?.total_item} Item
                  </h4>
                </div>
                </div>
                <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Total Weight")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.order_detail?.total_weight} Kg
                  </h4>
                </div>
                </div>
                <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Total Volume")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.order_detail?.total_volume} m<sup>3</sup>
                  </h4>
                </div>
                </div>
                </div>
            {detail?.order_detail?.order_item?.map((el, i) => {
          return (
            <div id={i}>
              <Accordion
                onClick={() => clickCard(i, isOpen)}
                index={i}
                i={index}
                isOpen={isOpen}
                isMenu="shippingcost"
                address={el?.item_brand+" - "+el?.item_name+" - "+el?.number_of_item+" Pcs"}
                body={
                  <>
                    {isOpen === true && i === index ? (
                      <>

                        <div className="flex flex-col gap-[40px] ml-10">
                          <div>
                            {/* <h3 className="font-roboto text-[18px] font-medium mb-6 mt-6">
                              {t("Item Detail")}
                            </h3> */}
        <CustomDivider name={"Item Detail"} />
                            <div className="flex">
                              {/* line one */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                                    {t("Item Brand")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                                    {el?.item_brand}
                                  </h4>
                                </div>
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                                    {t("Number of Item")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                                    {el?.number_of_item} Pcs
                                  </h4>
                                </div>
                              </div>
                              {/* line two */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[500px] mb-[24px]">
                                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                                    {t("Item Name")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                                    {el?.item_name}
                                  </h4>
                                </div>
                              </div>
                              {/* line three */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                                    {t("Item Category")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                                    {el?.item_category}
                                  </h4>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="flex flex-col gap-[40px] ml-10">
                          <div>
                            {/* <h3 className="font-roboto text-[18px] font-medium mb-6 mt-6">
                              {t("Specification Detail")}
                            </h3> */}
        <CustomDivider name={"Specification Detail"} />
                            <div className="flex">
                              {/* line one */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                                    {t("Width")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                                    {el?.width} M
                                  </h4>
                                </div>
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                                    {t("Weight")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                                    {el?.weight} Kg
                                  </h4>
                                </div>
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                                    {t("Subtotal Weight")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                                    {el?.subtotal_weight} Kg
                                  </h4>
                                </div>
                              </div>
                              {/* line two */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[500px] mb-[24px]">
                                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                                    {t("Height")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                                    {el?.height} M
                                  </h4>
                                </div>
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                                    {t("Volume")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                                    {el?.volume} m<sup>3</sup>
                                  </h4>
                                </div>
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                                    {t("Subtotal Case Weight")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                                    {el?.subtotal_case_weight} Kg
                                  </h4>
                                </div>
                              </div>
                              {/* line three */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[500px] mb-[24px]">
                                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                                    {t("Length")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                                    {el?.length} M
                                  </h4>
                                </div>
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                                    {t("Subtotal Volume per Item")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                                    {el?.subtotal_volume} m<sup>3</sup>
                                  </h4>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                        <div className="flex flex-col gap-[40px] ml-10">
                          <div>
                            {/* <h3 className="font-roboto text-[18px] font-medium mb-6 mt-6">
                              {t("Pallet")}
                            </h3> */}
        <CustomDivider name={"Pallet"} />
                            <div className="flex">
                              {/* line one */}
                              <div className="gap-[40px] mb-[24px]">
                                <div className="w-[400px] mb-[24px]">
                                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                                    {t("Pallet")}
                                  </label>
                                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                                    {el?.is_use_pallet}
                                  </h4>
                                </div>
                              </div>
                              {
                                el?.is_use_pallet === "Y" ?
                                  <>
                                    <div className="gap-[40px] mb-[24px]">
                                      <div className="w-[400px] mb-[24px]">
                                        <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                                          {t("Pallet")}
                                        </label>
                                        <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                                          {el?.pallet_name}
                                        </h4>
                                      </div>
                                    </div>
                                    <div className="gap-[40px] mb-[24px]">
                                      <div className="w-[400px] mb-[24px]">
                                        <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                                          {t("Number of Item per pallet")}
                                        </label>
                                        <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                                          {el?.number_of_item_per_pallet}
                                        </h4>
                                      </div>
                                    </div>
                                  </>
                                  :
                                  <></>
                              }
                            </div>
                          </div>
                        </div>
                      </>
                    ) : null}
                  </>
                }
              />
            </div>
          );
        })}
          </div>
        </div>
      </>
    );
  };

  const Delivery = () => {
    return (
      <>
        <ModalMaps
          show={isOpenMaps}
          address={detail?.delivery_detail?.address}
          latitude={detail?.delivery_detail?.latitude}
          longitude={detail?.delivery_detail?.longitude}
          onClose={() => setIsOpenMaps(false)}
          loc={loc + ", " + (loc2 ? loc2 + ", " : "") + detail?.delivery_detail?.longitude + ", " + detail?.delivery_detail?.latitude}
        />
        <div className="flex flex-col gap-[40px]">
          <div>
            {/* <h3 className="font-roboto text-[18px] font-medium mb-6 mt-6">
              {t("Customer Information")}
            </h3> */}
        <CustomDivider name={"Customer Information"} />
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Customer ID")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.delivery_detail?.customer_id}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Customer Email")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.delivery_detail?.email}
                  </h4>
                </div>
              </div>
              {/* line two */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Customer Name")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.delivery_detail?.customer_name}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Customer Fax")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.delivery_detail?.fax ? detail?.delivery_detail?.fax : "-"}
                  </h4>
                </div>
              </div>
              {/* line three */}
              <div className="gap-[40px] mb-[24px]">
                
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Customer Phone")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.delivery_detail?.phone}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-[40px]">
          <div>
            {/* <h3 className="font-roboto text-[18px] font-medium mb-6 mt-6">
              {t("Customer Address")}
            </h3> */}
        <CustomDivider name={"Customer Address"} />
            <div className="flex">
              {/* line one */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Country")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.delivery_detail?.country}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("District")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.delivery_detail?.district}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Address")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.delivery_detail?.address}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Postal Code")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.delivery_detail?.postal_code}
                  </h4>
                </div>
                
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Pinpoin")}
                  </label>
                  <MapsSmall
                    long={detail?.delivery_detail?.longitude}
                    lat={detail?.delivery_detail?.latitude}
                    // onClicks={() => setIsOpenMaps(true)}
                    onClicks={() =>
                      getAdr(detail?.delivery_detail?.longitude, detail?.delivery_detail?.latitude)
                    }
                    />
                </div>
              </div>
              {/* line two */}
              <div className="gap-[40px] mb-[24px]">
                {/* <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Island")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.delivery_detail?.island}
                  </h4>
                </div> */}
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Sub District")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.delivery_detail?.sub_district}
                  </h4>
                </div>
                
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Neighbourhood")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.delivery_detail?.neighbour ? detail?.delivery_detail?.neighbour : "-"}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Longitude")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.delivery_detail?.longitude}
                  </h4>
                </div>
                {/* <div className="w-[500px] mb-[24px]">
              <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                {t("Address 2")}
              </label>
              <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                {detail?.delivery_detail?.address_2}
              </h4>
            </div> */}
              </div>
              {/* line three */}
              <div className="gap-[40px] mb-[24px]">
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Province")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.delivery_detail?.province}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Urban Village")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.delivery_detail?.urban_village}
                  </h4>
                </div>
                
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Hamlet")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.delivery_detail?.hamlet ? detail?.delivery_detail?.hamlet : "-"}
                  </h4>
                </div>
                <div className="w-[500px] mb-[24px]">
                  <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                    {t("Latitude")}
                  </label>
                  <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                    {detail?.delivery_detail?.latitude}
                  </h4>
                </div>
                {/* <div className="w-[500px] mb-[24px]">
              <label className="font-roboto text-[14px] font-nornal text-[#818181]">
                {t("Address 3")}
              </label>
              <h4 className="font-roboto text-[20px] font-medium text-[#424242]">
                {detail?.delivery_detail?.address_3}
              </h4>
            </div> */}
                
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const items = [
    {
      key: 1,
      label: t("Order Detail"),
      children: Order(),
    },
    {
      key: 2,
      label: t("Delivery Detail"),
      children: Delivery(),
    },
  ];

  const doPost = async (endpoint, tkn, data, dispatch, refresh_token) => {
    // const api = `http://app.sbp:9038/v1/grolog`;
    const api = GROLOG_ORDER_URL;

    const url = api + endpoint;
    const method = "POST";
    const headers = {
      Authorization: token,
    };
    const request = { url, method, headers, data };
    return axios(request);
  };
  const onPaid = async () => {
    let cek = [];
    // let id=
    // dataCheck?.map((el) => {
    //   cek.push({
    //     id: el.id,
    //     updated_at: el.updated_at,
    //   });
    // });
    let list_trip = { list_id:[detail], is_check_all:isAllChecked };

    try {
      let tkn = token;
      let res = await doPost(`/shipping-cost-payment/paid?${param}`, tkn, list_trip);
      // setSuccessModalOpen(true);
      // message.success(_.startCase("Success Start Trip"));
      setMessages("Success Paid");
      setSuccessModalOpen(true);
      setStartOpen(false);
    } catch (err) {
      if (
        err.response.data.payload.message ===
        "Data with this Additional Name is already used by other, cant process this action"
      ) {
        // setErr(err.response.data.payload.message)
      } else {
        // message.error(_.startCase(err.response.data.payload.message));
        setMessages(err.response.data.payload.message);
        setFailedModalOpen(true);
        setStartOpen(false);
      }
    }
  };
  const actModal = () => {
    setSuccessModalOpen(false);
    setFailedModalOpen(false);
    setStartOpen(false);
    setMessages("");
    navigate(ROUTES.SHIPPING_COST_PAYMENT.LIST)
  };
  
  return (
    <>
      <ModalStartEndTrip
        visible={startOpen}
        styles={" w-[200px] ml-[-20px]"}
        message={`Are you sure want to change to paid?`}
        message2={"If you have changed, the status cant be edited again"}
        titles="Change"
        widthPaid="499px"
        title2="Change Payment Status?"
        isPaid={true}
        onClick={() => onPaid()}
        action={() => setStartOpen(false)}
      />
      {/* <ModalStartEndTrip
        visible={endOpen}
        styles={" w-[200px] ml-[-20px]"}
        message={`Are you sure want to approve`}
        title="Reject Order"
        onClick={() => onEnd()}
        action={() => setEndOpen(false)}
      /> */}
      <ModalSuccessAdd
        show={successModalOpen}
        action={() => actModal()}
        closable={false}
        width={280}
        className={style.deleteModal}
        okText="Ok"
        title="Success"
        description={messages}
      />
      <ModalFailedDelete
        show={failedModalOpen}
        action={() => actModal()}
        closable={false}
        width={414}
        className={style.deleteModal}
        okText="Ok"
        title="Data Cant be added"
        description={messages}
      />
      <div className="p-[24px] flex flex-col gap-[24px]">
        <div>
          <Breadcumbs
            jmlLevel={3}
            menuLevel1={`Order`}
            menuLevel2={`Shipping Cost Payment`}
            menuLevel3={
              `Detail ` + detail?.order_detail?.distributor_name + " - " + detail?.order_detail?.sales_invoice_number
            }
          />
        </div>

        <div className="flex items-center justify-between">
          <div
            onClick={() => navigate(ROUTES.SHIPPING_COST_PAYMENT.LIST)}
            className="cursor-pointer flex items-center gap-[22px]"
          >
            <img src={BackIcon} alt="" className="cursor-pointer" />
            <h1 className="font-bold text-[28px]" id="title">
              Detail {detail?.order_detail?.distributor_name + " - " + detail?.order_detail?.sales_invoice_number}
            </h1>
            <img src={detail?.payment_status==="Unpaid" ? UnpaidIcon : PaidIcon} alt="pay"/>
          </div>
          <div
            className="bg-[#EEEEEE] rounded-[6px] px-[12px] py-[7px] cursor-pointer"
            onClick={() => setUserManagementOpen(true)}
          >
            <p className="text-[#666666]">
              {t("USER_DETAIL:CREATED_BY")}{" "}
              <strong>{detail?.created_by}</strong> {t("USER_DETAIL:ON")}{" "}
              <strong>{convertTimestamp(detail?.created_at, true)}</strong> |{" "}
              {t("USER_DETAIL:LAST_MODIFIED_BY")}{" "}
              <strong>{detail?.updated_by}</strong> {t("USER_DETAIL:ON")}{" "}
              <strong>{convertTimestamp(detail?.updated_at, true)}</strong>
            </p>
          </div>
        </div>

        <div
          style={{
            marginTop: 24,
            padding: 30,
            minHeight: 512,
            borderRadius: "6px",
            backgroundColor: "white",
            boxShadow: "0px 3px 6px rgba(0, 0, 0, 0.16)",
          }}
        >
          <div className={style.tabsContainer + ""}>
            <Tabs
              defaultActiveKey="1"
              items={items}
              className="border-b border-[#ffffff]"
            />
          </div>
        </div>
        <ManagementHistory
                    id={detail?.order_id}
                    detail={detail}
                    tableName={"gromart_order"}
                    userManagementOpen={userManagementOpen}
                    setUserManagementOpen={() => setUserManagementOpen(false)}
                />
        <div className="flex flex-row-reverse gap-[16px]">
          {detail?.payment_status==="Unpaid" ?
          <PrimaryButton
            text={t("Paid")}
            action={() => setStartOpen(true)}
          />
          : <></>}
          <SecondaryButton
            text={t("Back")}
            action={() => navigate(ROUTES.SHIPPING_COST_PAYMENT.LIST)}
          />
        </div>
      </div>
    </>
  );
};

export default DetailShippingCost;
